import { useTheme } from '@lokalise/styled'

/**
 * @deprecated use `@lokalise/styled` directly
 */
export {
	type CSSProperties,
	type CssDeclaration,
	createGlobalStyle,
	css,
	keyframes,
	styled,
	styled as default,
	ThemeProvider,
	useTheme,
} from '@lokalise/styled'

export const useCurrentMode = () => useTheme().mode
